import React from "react";
import './Error.scss'
import warning from '../../Assets/Icons/warning.svg'
import BaseButton from "../BaseButton/BaseButton";
import BottomSheet from "../BottomSheet/BottomSheet";
import {useTranslation} from "react-i18next";

interface Props {
    show: boolean,
    close?: () => void
    title: string,
    subTitle?: string,
    btnTxt?: string
}

const Error: React.FC<Props> = ({show, close, title, subTitle, btnTxt}: Props) => {
    const {t} = useTranslation('common')
    return (
        <BottomSheet show={show} close={close}>
            <div className="error">
                <img className="error--img" src={warning} alt={t('alt.warningIcon')} />
                <p className="error--title">{title}</p>
                {subTitle && <p className="error--subTitle">{subTitle}</p>}
                {
                    close && <BaseButton onClick={close} text={btnTxt || t('actions.back')} className="error--btn"/>
                }
            </div>
        </BottomSheet>
    )
}

export default Error
